import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { WelaraMinutesService } from '../../../../services/welara-minutes.service';
@Component({
  selector: 'app-form-party-external',
  templateUrl: './form-party-external.component.html',
  styleUrls: ['./form-party-external.component.css']
})
export class ExternalPartyComponent implements OnInit {
  @Output() partyToMinutesGrid = new EventEmitter<string>();
  errorMsg = "";
  externalPartyID = -1;
  partyForm: any = {
    id:-1,
    f_name: '',
    m_name: '',
    l_name: '',
    first_last:'',
    company_name: '',
    w_email: '',
    linkedin_link: '',
    title: ''
  };

  isContentLoaded = false;
  authUser = sessionStorage.getItem('wOSAuthUser');
  userID = this.authUser;
  constructor(
    private minutesService: WelaraMinutesService
  ) {}

  ngOnInit(): void {
    this.loadExternalUserData();
  }

  loadExternalUserData(): void {
    console.log("loadExternalUserData")
  }

  addParty(): void {
    if (this.partyForm.f_name == '') {
      this.errorMsg = 'First Name is required';
      setTimeout(() => this.errorMsg = '', 3000);
      return;
    }
    if (this.partyForm.l_name == '') {
      this.errorMsg = 'Last Name is required';
      setTimeout(() => this.errorMsg = '', 3000);
      return;
    }
    if (this.partyForm.w_email == '') {
      this.errorMsg = 'Email Address is required';
      setTimeout(() => this.errorMsg = '', 3000);
      return;
    }
    if (this.partyForm.company_name == '') {
      this.errorMsg = 'Company Name is required';
      setTimeout(() => this.errorMsg = '', 3000);
      return;
    }
    if (this.partyForm.title == '') {
      this.errorMsg = 'Title is required';
      setTimeout(() => this.errorMsg = '', 3000);
      return;
    }
    const ret = JSON.stringify(this.partyForm)
    this.partyToMinutesGrid.emit(ret);
    this.externalPartyID--;
    this.resetExternalParty()
  }

  resetExternalParty(): void {
    this.partyForm = {
      id: this.externalPartyID,
      f_name: '',
      m_name: '',
      l_name: '',
      first_last: '',
      company_name: '',
      w_email: '',
      linkedin_link: '',
      title: ''
    };
    $('#focusField').trigger('focus');
  }

}
